<template>
  <el-dialog
    :title="model.id > 0 ? '编辑回款' : '添加回款'"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
    @open="opened"
    :close-on-click-modal="false"
  >
    <el-form ref="form" label-width="100px" :model="model" :rules="formRules">
      <el-form-item label="订单" v-if="order">
        <label>{{ order.number }}</label>
      </el-form-item>
      <el-form-item label="订单" v-else prop="customer_order_id">
        <el-select
          size="small"
          v-model="model.customer_order_id"
          placeholder="请选择订单"
          @change="changedOrder()"
        >
          <el-option
            v-for="item in orders"
            :key="item.number"
            :label="item.number"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="回款金额" prop="amount">
        <el-input
          style="width: 220px"
          size="small"
          v-model="model.amount"
          placeholder="回款金额"
        ></el-input>
      </el-form-item>
      <el-form-item label="到账日期">
        <el-date-picker
          size="small"
          v-model="model.date"
          type="date"
          placeholder="请选择到账时间"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="submiting" @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  customerOrderList,
  createCustomerCollection,
  updateCustomerCollection,
} from '../service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default: null,
    },
    customerID: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
    model() {},
  },
  data() {
    return {
      visible: this.show,
      formRules: {
        customer_order_id: [
          { required: true, message: '请选择订单', trigger: 'change' },
        ],
      },
      orders: [],
      submiting: false,
    }
  },
  created() {},
  methods: {
    async requestOrders() {
      let data = {
        customer_id: this.customerID,
        not_status: 100,
      }
      let res = await customerOrderList(data)
      this.orders = res.data.list
    },
    opened() {
      if (!this.order) {
        this.requestOrders()
      }
    },

    changedOrder() {},
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          this.model.amount = parseFloat(this.model.amount)
          if (this.model.id > 0) {
            let res = await updateCustomerCollection(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createCustomerCollection(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.submiting = false
          this.visible = false
        } else {
          this.submiting = false
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>